var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M13.465 3H19a1 1 0 0 1 0 2h-1v15a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v11h12V5H1a1 1 0 1 1 0-2h5.535a3.5 3.5 0 0 1 6.93 0zm-2.05 0a1.5 1.5 0 0 0-2.83 0h2.83zM6.5 7.91c0-.503.448-.91 1-.91s1 .407 1 .91v8.18c0 .503-.448.91-1 .91s-1-.407-1-.91V7.91zm5 0c0-.503.448-.91 1-.91s1 .407 1 .91v8.18c0 .503-.448.91-1 .91s-1-.407-1-.91V7.91z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.90af094bfef9a9a6ebd8f85177cbeaa9.svg";
export { ForwardRef as ReactComponent };